import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { Api } from "../services/Api.jsx";

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [auth, setAuth_] = useState(null);

  const setAuth = (newAuth) => {
    setAuth_(newAuth);
  };

  useEffect(() => {
    if (auth) {
      Api.defaults.headers.common["Authorization"] = `Bearer ${auth.token}`;
    } else {
      delete Api.defaults.headers.common["Authorization"];
      setAuth(null);
    }
  }, [auth]);

  const contextValue = useMemo(
    () => ({
      auth,
      setAuth,
    }),
    [auth],
  );

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access to the auth context
export const useAuth = () => useContext(AuthContext);
export default AuthProvider;
